namespace Matrix.Exceptions {
    export interface ExceptionLinkForm {
        ExceptionSource: Serenity.StringEditor;
        ExceptionContext: Serenity.StringEditor;
        ExceptionKey: Serenity.StringEditor;
        LinkToTable: Serenity.StringEditor;
        LinkToEntityKey: Serenity.StringEditor;
        RowId: Serenity.StringEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class ExceptionLinkForm extends Serenity.PrefixedContext {
        static formKey = 'Exceptions.ExceptionLink';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExceptionLinkForm.init)  {
                ExceptionLinkForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(ExceptionLinkForm, [
                    'ExceptionSource', w0,
                    'ExceptionContext', w0,
                    'ExceptionKey', w0,
                    'LinkToTable', w0,
                    'LinkToEntityKey', w0,
                    'RowId', w0,
                    'Version', w1,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2
                ]);
            }
        }
    }
}
